angular.module('capability-ng-academic-planner').component('planFeedbackTerm', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_term/plan_feedback_term.html',
  bindings: {
    term: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_term/plan_feedback_term.ts